<div
  (keydown.escape)="handlingEscape($event)"
  class="idp-menu"
  [ngStyle]="styles.container || null"
>
  <div class="idp-menu__icon" [ngStyle]="styles.icon || null">
    <button
      class="btn btn-default btn-filter-results rounded-0 outlineArea"
      [ngClass]="_open ? 'active' : ''"
      (click)="menuIconClick()"
      role="button"
      type="button"
      aria-expanded="false"
    >
      <div class="idp-menu__isDesktop idp-menu__filter-text">
        <span class="float-left">{{ content.button.label }}</span>
        <span
          class="white-arrow"
          [ngClass]="_open ? 'up-arrow' : 'down-arrow'"
        ></span>
        <span class="idp-sr-only">
          {{ content.button.screenReaderLabel }}
        </span>
      </div>
      <div
        *ngIf="content?.button?.icon"
        class="idp-menu__isNotDesktop filter-icon"
        [innerHtml]="content.button.icon || '' | trustContent : 'svg'"
      ></div>
    </button>
  </div>
  <div
    class="idp-dialog idp-dialog-{{ displayProperties.type }}"
    *ngIf="_open"
    data-test-modal-wrapper="true"
    [ngClass]="{ 'overflow-hidden': scrollModal }"
    [ngStyle]="styles.content || null"
  >
    <div
      class="idp-dialog__body"
      data-test-modal-body="true"
      [attr.role]="roleType"
      [attr.aria-label]="getAriaLabel(displayProperties, modalTitle)"
      [attr.tabindex]="displayProperties && displayProperties.focus ? 0 : -1"
      #simpleModalRef
      [ngStyle]="styles.body?.container || null"
    >
      <div
        *ngIf="config?.showHeader"
        class="idp-dialog__header header--{{
          headerStyle
        }} closeOnBackgroundClick"
        [ngClass]="{
          'idp-menu__flex-direction--unset': !showCloseIcon,
          'idp-dialog__header__divider': displayProperties.classname
        }"
        [ngStyle]="styles.header?.content || null"
      >
        <button
          *ngIf="showCloseIcon"
          (click)="close($event)"
          (keydown.shift.tab)="tabPrevious($event)"
          aria-label="Close Dialog"
          data-test-dialog-close="true"
          class="idp_dialog__close idp_dialog__close--{{ headerStyle }}"
          type="button"
          [ngStyle]="styles.header?.closeIcon || null"
        >
          <i aria-hidden="true" class="idp-close-icon"></i>
        </button>
        <a
          href="javascript:void(0);"
          id="filterexpanded"
          class="searchLinkText float-left"
          (click)="headerLinkClickEvent()"
          role="button"
          [ngStyle]="styles.header?.link || null"
        >
          {{ content.headerLink }}
        </a>
        <span
          class="idp-dialog__open-pointer"
          *ngIf="displayProperties?.classname"
        ></span>
      </div>
      <div
        [ngClass]="{
          'idp-dialog__content': true,
          'idp-menu__scroll': scrollModal
        }"
        [attr.tabindex]="tabIndex"
        [ngStyle]="styles.body?.content || null"
      >
        <ng-content></ng-content>
      </div>
      <div
        *ngIf="showFooter"
        class="idp-dialog__footer idp-dialog__footer--align-left"
        [ngStyle]="styles.footer || null"
      >
        <idp-button
          (click)="close($event)"
          (notify)="close($event)"
          (keydown.tab)="focus($event)"
          [ariaPopup]="openWindow"
          [label]="cancelButtonTitle"
          [size]="cancelButtonSize"
          [type]="modalType"
        ></idp-button>
      </div>
    </div>
  </div>
  <div
    *ngIf="loadBackground && _open"
    (click)="outsideModal($event)"
    data-test-dialog-background="true"
    class="idp-dialog-background"
    [ngStyle]="styles.background || null"
  ></div>
</div>
